import moment from 'moment';
import _ from 'lodash';
import { TimeMap } from './time-data';

export const TimeUtils = {
  parseDate (stringDate) {
    const date = new Date(stringDate);
    const y = moment(date).get('year');
    const m = moment(date).get('month') + 1; // adding one to make it non-zero based months
    const d = moment(date).get('date');
    return {
      y,
      m,
      d
    };
  },
  createTimeHashFromKey (key) {
    return {
      h: TimeMap[key].h,
      m: TimeMap[key].m
    };
  },
  scheduleHash (startOrEnd, date, timeIndex) {
    const schedule = {};
    const dateHash = date ? { date: this.parseDate(date) } : {};
    const timeHash = timeIndex ? { time: this.createTimeHashFromKey(timeIndex) } : {};
    schedule[startOrEnd] = { ...dateHash, ...timeHash };
    return schedule;
  },
  findTimeIndex (time, isEndTime) {
    const whichTimeMap = isEndTime ? _.omit(TimeMap, 0) : TimeMap;
    const { h, m } = time;
    const filteredTime = _.filter(whichTimeMap, (value) => {
      if ((value.m === m) && (value.h === h)) return value;
    });
    return _.get(filteredTime, '0.time_index', null);
  }
};
